import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@mui/material';
import { IconButton } from '@totalsoft/rocket-ui';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import TextTableCell from 'components/common/table/TextTableCell';

const RequiredDocumentItem = ({ data, onDelete }) => {
  const [t] = useTranslation();
  const historyContext = useHistoryWithContext();

  const handleEdit = useCallback(() => {
    historyContext.push(`/requiredDocuments/${data.requiredDocTypeId}`);
  }, [historyContext, data]);

  return (
    <TableRow>
      <TextTableCell content={data.documentName} />
      <TextTableCell content={data.documentCode} />
      <TextTableCell content={data.sharePointContentType} />
      <TableCell align='right'>
        <IconButton type='edit' size='small' variant='text' color='primary' tooltip={t('Edit')} onClick={handleEdit} />
        <IconButton
          type='delete'
          size='small'
          variant='text'
          color='primary'
          tooltip={t('Delete')}
          onClick={() => onDelete(data.requiredDocTypeId)}
        />
      </TableCell>
    </TableRow>
  );
};

RequiredDocumentItem.propTypes = {
  data: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default RequiredDocumentItem;
